export default __webpack_public_path__ + "static/woocommerce-4d61ab184ad3a322b9b4fed5ac2a4b31.png";